exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-notification[data-v-20987e16]{margin-left:0}.select-style[data-v-20987e16] .ui.selection.dropdown .menu{max-height:150px}.checkboxes-field label[data-v-20987e16]{display:block;padding-right:10px;padding-left:22px;text-indent:-22px}.checkboxes-field input[data-v-20987e16],.checkboxes-field label span[data-v-20987e16]{vertical-align:middle}.currency-select[data-v-20987e16]{max-width:70px}@media (max-width:768px){.expense-type-responsive[data-v-20987e16]{height:50px}}", ""]);

// exports
